import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { CaseType } from '../../../pipes/case.pipe';

@Component({
  selector: 'app-step',
  imports: [],
  template: ``,
  styles: ``,
})
export class StepComponent {
  @Input()
  label: string;

  @Input()
  labelCase: CaseType = 'sentence';

  @Input()
  icon: string;

  @Input({ required: true })
  name: string;

  @ContentChild(TemplateRef)
  template: TemplateRef<any>;
}
